var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "header" } }, [
    _c("img", {
      attrs: {
        id: "logo",
        src: _vm.siteLogo,
        alt: "",
        onerror: "this.style.display = 'none';",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }